import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import {Trans, withTranslation} from "react-i18next";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import MSign from "./Sign/MSign";
import SmartId from "./Sign/SmartId";
import BankSign from "./Sign/Banksign";
import Ondato from "./Ondato";
import Loading from "./Parts/Loading";

class SignContract extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bankLinkUrls: [],
            file_id: null,

            show_ondato: true,
            waiting_info: true,
            can_sign_by_one_ct: false,

            step_count: 4,
            current_step: 4,
            redirectToNextStep: false,
            ondato_identification_id: null,
            trackDataLoaded: false
        };

        axios.get('/api/process/' + this.props.application_token + '/contract_sign_methods_info')
            .then(
                data => {
                    if (data.data.status === 'success') {
                        gtm.sendEvent('base', {
                            orderID: this.props.suggestion.application.id,
                            event: 'checkoutcontract3',
                            actionField: { step: 9, action: 'signContract' },
                            products: {
                                price: this.props.suggestion.amount,
                                variant: this.props.suggestion.term,
                                product_code: this.props.suggestion.product,
                            },
                            pageTitle: 'Sign the contract 3/3',
                            eventId: 3617
                        });
                        this.setState({
                            show_ondato: data.data.data.needs_ondato,
                            can_sign_by_one_ct: data.data.data.can_sign_by_one_ct,
                            ondato_identification_id: data.data.data.ondato_identification_id,
                        });
                    }

                    axios.get('/api/process/' + this.props.application_token + '/contract_sign_links')
                        .then(
                            data => {
                                if (data.data.status === 'success') {
                                    this.setState({
                                        bankLinkUrls: data.data.data.links,
                                        file_id: data.data.data.file_id,
                                        waiting_info: false,
                                    });
                                }
                            },
                            error => {
                                this.setState({ error: error });
                            }
                        )
                        .catch((a, b, c) => {
                            console.log(a, b, c);
                        });
                },
                error => {
                    this.setState({ error: error });
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });


        this.callbackAfterSign = this.callbackAfterSign.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.suggestion.amount !== undefined
            && this.props.suggestion.amount !== ''
            && !this.state.trackDataLoaded
        ) {
            this.setState({ trackData: {
                    loan_amount: this.props.suggestion.amount,
                    loan_period: this.props.suggestion.term,
                    product_code: this.props.suggestion.application?.appl_product,
                    application_number: this.props.suggestion.application.id,
                },
                trackDataLoaded: true
            });
        }
    }
    callbackAfterSign() {
        this.setState({redirectToNextStep: true});
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/' + this.props.application_token + '/process/done'}/>
        }

        return (
            <div>
                <Header title={this.props.t('step.contract')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.sign_contract')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>
                        <div className="row">

                            {this.state.waiting_info || !this.props.suggestion.application.proposal ?
                                <div className="tab-content frame p-4 p-sm-5 w-100">
                                    {this.state.error === null ?
                                        <Loading/> : ''
                                    }
                                </div>
                                :
                                <div className="tab-content frame p-4 p-sm-5 w-100" id="authTabContent">
                                    {this.props.suggestion.signing_failed_msg ?
                                        <div className="alert alert-warning">
                                            {this.props.suggestion.signing_failed_msg}
                                        </div>
                                        :
                                        ''
                                    }
                                    <div aria-labelledby="private-tab" className="tab-pane fade show active"
                                         id="private"
                                         role="tabpanel">

                                        <ul className="nav nav-tabs bg-gray-cloud justify-content-center"
                                            id="authDeviceTab"
                                            role="tablist">
                                            {this.state.can_sign_by_one_ct ?
                                                <li className="nav-item">
                                                    <a aria-controls="auth-id-bank"
                                                       aria-selected={this.state.can_sign_by_one_ct ? "true" : "false"}
                                                       className="nav-link"
                                                       data-toggle="tab" href="#auth-id-bank" id="auth-id-bank-tab"
                                                       role="tab">
                                                        <i className="icons icon-building"></i> Per el. bankininkystę
                                                    </a>
                                                </li>
                                                :
                                                ''
                                            }

                                            {(!this.props.suggestion.is_eshop || this.props.suggestion.application.proposal.amount_advance === 0) &&
                                            <li className="nav-item">
                                                <a aria-controls="auth-mobile-id"
                                                   aria-selected={this.state.can_sign_by_one_ct ? "false" : "true"}
                                                   className="nav-link"
                                                   data-toggle="tab"
                                                   href="#auth-mobile-id"
                                                   id="auth-mobile-id-tab"
                                                   role="tab">
                                                    <i className="icons icon-phone"></i> M. parašu
                                                </a>
                                            </li>
                                            }

                                            {(!this.props.suggestion.is_eshop || this.props.suggestion.application.proposal.amount_advance === 0) &&
                                            <li className="nav-item">
                                                <a aria-controls="auth-smart-id" aria-selected="false"
                                                   className="nav-link active"
                                                   data-toggle="tab" href="#auth-smart-id" id="auth-smart-id-tab"
                                                   role="tab">
                                                    <i className="icon-smartid"></i>Smart-ID
                                                </a>
                                            </li>
                                            }
                                        </ul>
                                        <div className="tab-content border py-3" id="authDeviceTabContent">

                                            {this.state.can_sign_by_one_ct ?
                                                <div aria-labelledby="auth-id-bank-tab"
                                                     className="tab-pane fade"
                                                     id="auth-id-bank"
                                                     role="tabpanel"
                                                >
                                                    <div className="container py-4">
                                                        <div className="row bank-links d-flex justify-content-center">
                                                            <div className="col-12 col-md-8">
                                                                {this.state.show_ondato ?
                                                                    <Ondato
                                                                        application_token={this.props.application_token}
                                                                        successCallback={() => {
                                                                            this.setState({show_ondato: false})
                                                                        }}
                                                                        ondato_identification_id={this.state.ondato_identification_id}
                                                                    />
                                                                    :
                                                                    <Fragment>
                                                                        <div className="container">
                                                                            <BankSign
                                                                                bankLinkUrls={this.state.bankLinkUrls}/>
                                                                        </div>
                                                                        <div className="container mt-3">
                                                                            <div className="row">
                                                                                <div className="col-12">
                                                                                    <p>
                                                                                        <Trans
                                                                                            i18nKey="forms.have_questions">
                                                                                            Turite klausimų? Skambinkite
                                                                                            mums <a
                                                                                            href="tel:+37070070080">+370
                                                                                            700 700 80</a> ir mes Jums
                                                                                            padėsime atlikti dokumento
                                                                                            pasirašymą
                                                                                        </Trans>
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Fragment>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                ''
                                            }

                                            {(!this.props.suggestion.is_eshop || this.props.suggestion.application.proposal.amount_advance === 0) &&
                                            <div aria-labelledby="auth-mobile-id"
                                                 className={"tab-pane fade" + (!this.state.can_sign_by_one_ct ? " show active" : "")}
                                                 id="auth-mobile-id"
                                                 role="tabpanel">
                                                <div className="container py-5 p-lg-5">
                                                    <div className="row justify-content-md-center">
                                                        <MSign
                                                            file_id={this.state.file_id}
                                                            application_token={this.props.application_token}
                                                            phone={this.props.phone}
                                                            callback={this.callbackAfterSign}
                                                            trackData={this.state.trackData}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            }

                                            {(!this.props.suggestion.is_eshop || this.props.suggestion.application.proposal.amount_advance === 0) &&
                                            <div aria-labelledby="auth-smart-id" className="tab-pane fade show active"
                                                 id="auth-smart-id"
                                                 role="tabpanel">
                                                <div className="container py-5 p-lg-5">
                                                    <div className="row justify-content-md-center">
                                                        <SmartId file_id={this.state.file_id}
                                                                 application_token={this.props.application_token}
                                                                 callback={this.callbackAfterSign}
                                                                 trackData={this.state.trackData}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(SignContract);
